import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=27abc42a&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abc42a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27abc42a')) {
      api.createRecord('27abc42a', component.options)
    } else {
      api.reload('27abc42a', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=27abc42a&scoped=true", function () {
      api.rerender('27abc42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Settings.vue"
export default component.exports